<script setup>
defineProps({
  recommended: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="w-50 flex flex-wrap items-center">
    <BaseIcon v-if="recommended" name="HeroChatBubbleBottomCenterTextIconSolid" class="mr-1 w-4 text-red-400" />
    <BaseIcon v-else name="HeroChatBubbleBottomCenterTextIconOutline" class="mr-1 w-4 text-muted-foreground" />
    <p class="text-xs text-foreground-secondary">
      {{
        recommended ? $t('pages.review.reviewPage.items.recommend') : $t('pages.review.reviewPage.items.noRecommend')
      }}
    </p>
  </div>
</template>
